import "../../../../stylesheets/catalog";
import { donandoFooterColor } from "../../utils";

$(document).ready(function () {
  donandoFooterColor();
});
